(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/components/charity-container.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/components/charity-container.js');

'use strict';

const {
  CharityImg
} = svs.lyckoplatsen.components.page_start.react.components;
const {
  activeCharitiesAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;
const {
  useAtomValue
} = jotai;
const CharityContianer = () => {
  const activeCharities = useAtomValue(activeCharitiesAtom);
  if (!(activeCharities !== null && activeCharities !== void 0 && activeCharities.length)) {
    return null;
  }
  return React.createElement("div", {
    className: "lp-charity-container"
  }, React.createElement("div", {
    className: "lp-charity-body"
  }, React.createElement("h1", {
    className: "charity-header"
  }, " Spela f\xF6r en god sak "), React.createElement("p", {
    className: "charity-description"
  }, "Att spela Lyckoplatsen ska k\xE4nnas bra i hj\xE4rtat. D\xE4rf\xF6r kan du v\xE4lja att st\xF6tta en ideell organisation med 10% av din insats. ", React.createElement("b", null, "Det kostar allts\xE5 inget extra och har ingen p\xE5verkan \xF6ver dina vinstchanser. "), "Vi kallar det att spela f\xF6r en god sak. H\xE4r nedan kan du se vilka organisationer du kan v\xE4lja att st\xF6tta. Klicka p\xE5 logotypen f\xF6r att spela med organisationen som ditt val."), React.createElement("div", {
    className: "lp-charity-imgs"
  }, activeCharities.map(c => React.createElement(CharityImg, {
    charityProps: c,
    key: c.charityId
  })))));
};
setGlobal('svs.lyckoplatsen.components.page_start.react.components', {
  CharityContianer
});

 })(window);